
        import * as module0 from '$components/jquery.easing.min.js';import * as module1 from '$components/jquery.parallax.js';import * as module2 from '$components/main.js'
        const modules = {
            "jquery.easing.min.js": module0,
            "jquery.parallax.js": module1,
            "main.js": module2,
        };
        export default modules;
      